import { type PagesConfig } from "~/domains/pageSchemas";

export const fluggastrechteZusammenfassungPages = {
  zusammenfassungStart: {
    stepId: "/zusammenfassung/start",
  },
} satisfies PagesConfig;
